import type { RouteObject } from 'react-router-dom';

import { CommunityAuditGuard } from './components/CommunityAuditGuard';
import type { AuditSessionLoaderData } from './domain/AuditSessionLoaderData';
import { auditSessionLoader } from './loaders/auditSessionLoader';
import { AuditReportPage } from './pages/AuditReportPage';
import { AuditSessionDetailPage } from './pages/AuditSessionDetailPage';
import { AuditSessionsListPage } from './pages/AuditSessionsListPage';

/**
 * Get community-scoped audit route configuration
 * These routes will be integrated into the communities routing
 *
 * Uses CommunityAuditGuard for hybrid authorization:
 * - System Admin role (from user.roles)
 * - QA role in the specific community (from community.roles)
 * - Admin role in the specific community (from community.roles)
 */
export function getCommunityAuditRouteConfig(): RouteObject[] {
  return [
    {
      path: 'audits',
      handle: { breadcrumb: 'Audits' },
      children: [
        {
          index: true,
          element: (
            <CommunityAuditGuard>
              <AuditSessionsListPage />
            </CommunityAuditGuard>
          ),
        },
        {
          path: ':sessionId',
          loader: auditSessionLoader,
          handle: {
            breadcrumb: (data: AuditSessionLoaderData) => data?.auditSession?.name || 'Audit Session',
          },
          element: (
            <CommunityAuditGuard>
              <AuditSessionDetailPage />
            </CommunityAuditGuard>
          ),
        },
        {
          path: ':sessionId/reports',
          handle: { breadcrumb: 'Reports' },
          element: (
            <CommunityAuditGuard>
              <AuditReportPage />
            </CommunityAuditGuard>
          ),
        },
      ],
    },
  ];
}
